import {validateField, clearFields, setFieldOptions, setCheckBoxValue} from './helpers/form'
import {
  SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VACANCY_CRITERIA_SINGER_FIELD,
  CLEAR_VACANCY_CRITERIA_SINGER_FIELDS,
  SET_VACANCY_CRITERIA_CHECKBOX_VALUE
} from '../../../actions/pages/vacancy-page'

export function vacancyCriteriaSinger (
  state = {
    valid: false,
    fields: [
      {
        name: 'SkillLevel',
        value: '',
        errors: [],
        rules: {
          title: 'Rating'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'NativeLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Native language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AdditionalLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Additional language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AgeFrom',
        value: '',
        errors: [],
        rules: {
          title: 'Age from'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'AgeTo',
        value: '',
        errors: [],
        rules: {
          title: 'Age to'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'City',
        value: '',
        errors: [],
        rules: {
          title: 'Preferred  city'
        },
        placeholder: 'Any city',
        options: []
      },
      {
        name: 'CountryofLiving',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Country of residence'
        },
        placeholder: 'Any country',
        options: []
      },
      {
        name: 'Region',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Region'
        },
        placeholder: 'Any region',
        options: []
      },
      {
        name: 'Ethnicity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Ethnicity'
        },
        placeholder: 'Any ethnicity',
        options: []
      },
      {
        name: 'Identity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Identity'
        },
        placeholder: 'Any identity',
        options: []
      },
      {
          name: 'DoNotUse',
          value: '',
          type: 'checkbox',
          errors: [],
          rules: {
            title: 'Do not use'
          },
          options: []
      },
      {
        name: 'KnownTalent',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Known talent'
        }
      },
      {
        name: 'SkillVendorStatus',
        value: '',
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Inactive talent'
        },
        options: []
      },
      {
        name: 'SingerMaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Male'
        }
      },
      {
        name: 'SingerFemaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Female'
        }
      },
      {
        name: 'SingerVoiceAge',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Voice age'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'SingerVocalRange',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Vocal range'
        },
        placeholder: 'Any range',
        options: []
      },
      {
        name: 'SingerMusicNotesReadingLevel',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Reading music notes'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'SingerDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'SingerStageExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Stage'
        }
      },
      {
        name: 'SingerTheatreExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatre'
        }
      },
      {
        name: 'SingerTalentShowExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Talent show'
        }
      },
      {
        name: 'SingerStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Singer'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'SingerClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Singer'
        },
        placeholder: 'Any client'
      },
      {
        name: 'SingerSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'Singer'
        },
        placeholder: 'Any school'
      },
      {
        name: 'SingerUnion',
        type: 'select',
        value: '',
        errors: [],
        rules: {
          title: 'Union'
        },
        placeholder: 'Any union',
        options: []
      },
      {
        name: 'SingerRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      }
    ]
  },
  action
) {
  switch (action.type) {
    case SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'AgeFrom', action.ageFromList);
      newState = setFieldOptions(newState, 'CountryofLiving', action.country);
      newState = setFieldOptions(newState, 'Region', action.region);
      newState = setFieldOptions(newState, 'Ethnicity', action.ethnicity);
      newState = setFieldOptions(newState, 'Identity', action.identity);
      newState = setFieldOptions(newState, 'RemoteRecordingCapability', action.remoteRecordingCapabilityList);
      return setFieldOptions(newState, 'AgeTo', action.ageToList);
    }

    case SET_VACANCY_CRITERIA_CHECKBOX_VALUE: {
      var newState = setCheckBoxValue(state, 'KnownTalent', action.knownTalent);
      newState = setCheckBoxValue(newState, 'SkillVendorStatus', action.skillVendorStatus);
      return setCheckBoxValue(newState, 'DoNotUse', action.doNotUse);
    }

    case VALIDATE_VACANCY_CRITERIA_SINGER_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VACANCY_CRITERIA_SINGER_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
